var fn = function( obj ){
var __t,__p='';
__p+='#pragma SLOT version\n\n#pragma SLOT definitions\n\n#pragma SLOT precision\n\n'+
( require( "nanogl-pbr/glsl/includes/glsl-compat.vert" )() )+
'\n\n#pragma SLOT pv\n\nattribute vec3 aPosition;\nattribute vec2 aTexCoord0;\n\n\nuniform mat4 uM;\nuniform mat4 uVP;\n\nvarying vec2 vTexCoord0;\nvarying vec4 vScreenCoord;\nvarying vec4 worldSpaceCoord;\n\n\nvoid main(void){\n  #pragma SLOT v\n\n  #pragma SLOT vertex_warp_world\n  vTexCoord0 = aTexCoord0;\n  vScreenCoord = uVP * vec4(aPosition, 1.0);\n  worldSpaceCoord = vec4(aPosition, 1.0);\n  gl_Position = uVP * uM * vec4(aPosition, 1.0);\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;